import { startsWithAlphanumeric, usedMoreThanAllowed } from './utils';
import { updateVariationsErrors } from './variations';
import { getCategoryError } from './details';
import { setInvalid } from '../variations/errors';
import { getSize } from '../iterable/getSize';

import { ERRORS, MAXIMUM_PROFILE_NAME_LENGTH, PROFILE } from '../../constants/profiles';
import { CATEGORY, PRICE, TAGS } from '../../constants/attributes';
import { MAX_NUMBER_OF_TAGS } from '../../constants/validations';
import { EMPTY } from '../../constants';
import { ERROR } from '../../constants/product';
import { ETSY } from '../../constants/channels';

export function getProfileTitleError({ channel, title, titles, type }) {
  if (!title) {
    return ERRORS.NAME.EMPTY;
  } else if (titles?.has(title)) {
    return ERRORS.NAME.NON_UNIQUE;
  } else if (
    MAXIMUM_PROFILE_NAME_LENGTH.hasOwnProperty(channel) &&
    title.length > MAXIMUM_PROFILE_NAME_LENGTH[channel]
  ) {
    return ERRORS.NAME.LENGTH_EXCEEDED[channel];
  }

  if (type === PROFILE.SALES && channel === ETSY) {
    if (!startsWithAlphanumeric(title)) {
      return ERRORS.NAME.ALPHANUMERIC_BEGIN;
    } else if (/[^A-z0-9+\-=\/*%:& ]+/ug.test(title)) {
      return ERRORS.NAME.FORBIDDEN_CHARACTERS;
    } else if (usedMoreThanAllowed({ patterns: ['\\b\\p{Lu}{2,}\\b'], number: 3, value: title })) {
      return ERRORS.NAME.CAPITALIZED_WORDS_NUMBER_EXCEEDED;
    } else if (usedMoreThanAllowed({ patterns: ['[&]', '[%]', '[\:]', '[\u0026]', '[\u0025]', '[\u003A]'], number: 1, value: title })) {
      return ERRORS.NAME.SPECIAL_CHARACTERS_NUMBER_EXCEEDED;
    }
  }

  return false;
}

export function setProfileErrors({ type, profile: source }) {
  let profile = source;
  const errors = profile.get(ERROR, EMPTY.MAP);
  const channel = profile.get('channel');

  switch (type) {
    case PROFILE.VARIATIONS: {
      profile = updateVariationsErrors({ channel, variations: profile });

      switch (channel) {
        case ETSY: {
          const category = profile.get(CATEGORY);
          const error = getCategoryError({ channel, value: category });

          if (error) {
            profile = profile.setIn([ERROR, CATEGORY], error);
          } else if (profile.hasIn([ERROR, CATEGORY])) {
            profile = profile.deleteIn([ERROR, CATEGORY]);
          }

          break;
        }

        default: {
          break;
        }
      }

      break;
    }

    case PROFILE.TAGS: {
      profile = profile.setIn([ERROR, TAGS], getSize(profile.get(TAGS)) > MAX_NUMBER_OF_TAGS[channel]);
      break;
    }

    case PROFILE.SALES: {
      profile = profile
        .set(ERROR, errors)
        .setIn([ERROR, TAGS], getSize(profile.get(TAGS)) > MAX_NUMBER_OF_TAGS[channel])
        .setIn([ERROR, PRICE], !profile.get(PRICE) || profile.get(PRICE) <= 0);
      break;
    }

    default: {
      profile = profile.set(ERROR, errors);
      break;
    }
  }

  return setInvalid(profile);
}
